import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { LANGUAGES, TRANSLATIONS } from '../i18n/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'ar');

  useEffect(() => {
    const cfg = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    document.documentElement.lang = cfg.code;
    document.documentElement.dir = cfg.dir;
    localStorage.setItem('lang', lang);
  }, [lang]);

  const value = useMemo(() => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
    const t = (k) => dict[k] || TRANSLATIONS.en[k] || k;
    const isRTL = (LANGUAGES.find((l) => l.code === lang) || {}).dir === 'rtl';
    return { lang, setLang, t, isRTL, languages: LANGUAGES };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
